import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';
import FormPage from "./views/pages/FormPage.vue";

Vue.use(VueRouter);

let routes = [
    {
        path: '/',
        component: Dashboard,
        meta: {
            title: "dashboard",
        },
        alias: '/home'
    },
    {
        path: '/form/:bundle/:definition/:objectId?/:relationString?',
        name: 'formPage',
        component: FormPage,
        meta: {
            title: "Form"
        },
    },
];


routes = Vue.cmsRouter.setRoutes(routes);

const router = new VueRouter({
    routes
})

Vue.cmsRouter.setActiveRouter(router);

export default router;
